import React, { Component } from 'react';
import classNames from 'classnames';
export default class Form extends Component {
  constructor () {
    super();
  }

  render () {
    let columns = this.props.columns ? `columns ${this.props.columns}` : 'columns small-12';
    let rowClassName = this.props.noWrapInRow ? '' : 'row';
    let listWrapperClassName = 'form-items-container ' + (this.props.listWrapperClassName ? this.props.listWrapperClassName : '');
    rowClassName = classNames(rowClassName, this.props.className);

    return (
      <div className={rowClassName}>
        <div className={columns}>
          <ul className={listWrapperClassName}>
            {this.props.children}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/form/FormFieldWrapper.js